export default "__VITE_ASSET__Boygl3TV__"